'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: ['cell-left', {
        'cell-left-column': _vm.column || _vm.subTitle,
        'cell-left-has-icon': _vm.icon,
        'cell-left-has-subtitle': _vm.subTitle
      }]
    }, [_vm.icon ? _c('img', {
      staticClass: "cell-left-icon",
      attrs: {
        "src": _vm.icon
      }
    }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
      staticClass: "cell-left-subtitle"
    }, [_vm._v(_vm._s(_vm.subTitle))])], 2);
  },
  staticRenderFns: [],
  name: 'cell-left',
  props: {
    icon: String,
    column: Boolean,
    subTitle: String
  }
});

exports.default = index;
